import { render } from "./DiagramComponentRenderer.vue?vue&type=template&id=6cc029c2"
import script from "./DiagramComponentRenderer.vue?vue&type=script&lang=js"
export * from "./DiagramComponentRenderer.vue?vue&type=script&lang=js"

import "./DiagramComponentRenderer.vue?vue&type=style&index=0&id=6cc029c2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__